import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './actionTypes';
import Swal from 'sweetalert2';
import { post } from 'helpers/api_helper';
import { fetchShiftLateApprovalEmployeeFailure, fetchShiftLateApprovalEmployeeSuccess, fetchShiftLateCancelEmployeeFailure, fetchShiftLateCancelEmployeeSuccess } from './actions';

// ShiftLate
function* fetchShiftLateSaga(action) {
  const { unit_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);

    const response = yield call(post, process.env.REACT_APP_FETCH_SHIFT_LATE_LIST, formData);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch ShiftLate!');
    }

    yield put({ type: types.FETCH_TIME_DEDUCTION_SHIFT_LATE_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_TIME_DEDUCTION_SHIFT_LATE_FAILURE, payload: error });
  }
}

function* saveShiftLateSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_SHIFT_LATE, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save ShiftLate!');
    }

    yield put({ type: types.SAVE_TIME_DEDUCTION_SHIFT_LATE_SUCCESS });
    Swal.fire('Success', 'ShiftLate saved successfully!', 'success');
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.SAVE_TIME_DEDUCTION_SHIFT_LATE_FAILURE, payload: error });
  }
}

// ShiftLateCancel
function* fetchShiftLateCancelSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_SHIFT_LATE_CANCEL, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch ShiftLateCancel!');
    }

    yield put({ type: types.FETCH_TIME_DEDUCTION_SHIFT_LATE_CANCEL_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_TIME_DEDUCTION_SHIFT_LATE_CANCEL_FAILURE, payload: error });
  }
}

function* saveShiftLateCancelSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_SHIFT_LATE_CANCEL, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save ShiftLateCancel!');
    }

    yield put({ type: types.SAVE_TIME_DEDUCTION_SHIFT_LATE_CANCEL_SUCCESS });
    Swal.fire('Success', response?.message || 'ShiftLateCancel saved successfully!', 'success');
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.SAVE_TIME_DEDUCTION_SHIFT_LATE_CANCEL_FAILURE, payload: error });
  }
}

// ViewPunchOrders
function* fetchViewPunchOrdersSaga(action) {
  const { unit_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);

    const response = yield call(post, process.env.REACT_APP_FETCH_VIEW_PUNCH_ORDERS_URL, formData);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch ViewPunchOrders!');
    }

    yield put({ type: types.FETCH_VIEW_PUNCH_ORDERS_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_VIEW_PUNCH_ORDERS_FAILURE, payload: error });
  }
}

function* fetchShiftLateApprovalSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_SHIFT_LATE_APPROVAL, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch Shift Late Approval!');
    }

    yield put({ type: types.FETCH_SHIFT_LATE_APPROVAL_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_SHIFT_LATE_APPROVAL_FAILURE, payload: error });
  }
}

function* saveShiftLateApprovalSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_SHIFT_LATE_APPROVAL, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save Shift Late Approval!');
    }

    yield put({ type: types.SAVE_SHIFT_LATE_APPROVAL_SUCCESS });
    Swal.fire('Success', response?.message || 'Shift Late Approval saved successfully!', 'success');
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.SAVE_SHIFT_LATE_APPROVAL_FAILURE, payload: error });
  }
}

function* fetchLateReportSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_SHIFT_LATE_PROCESS_REPORT, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch Late Report!');
    }

    yield put({ type: types.FETCH_LATE_REPORT_SUCCESS, payload: response.data });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_LATE_REPORT_FAILURE, payload: error });
  }
}

function* fetchLateConsolidatedReportSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_SHIFT_LATE_PROCESS_CONSOLIDATE_REPORT, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch Late Consolidated Report!');
    }

    yield put({ type: types.FETCH_LATE_CONSOLIDATED_REPORT_SUCCESS, payload: response.data });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_LATE_CONSOLIDATED_REPORT_FAILURE, payload: error });
  }
}

function* fetchShiftLateApprovalEmployeeSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_SHIFT_LATE_APPROVAL_EMPLOYEE, action.payload);
    if (!response || response.status !== 'success') {
      throw new Error(response?.message);
    }
    yield put(fetchShiftLateApprovalEmployeeSuccess(response.data));
  } catch (error) {
    yield put(fetchShiftLateApprovalEmployeeFailure(error.message));
  }
}

function* fetchShiftLateCancelEmployeeSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_SHIFT_LATE_CANCEL_EMPLOYEE, action.payload);
    if (!response || response.status !== 'success') {
      throw new Error(response?.message);
    }
    yield put(fetchShiftLateCancelEmployeeSuccess(response.data));
  } catch (error) {
    yield put(fetchShiftLateCancelEmployeeFailure(error.message));
  }
}

export default function* shiftLateSagas() {
  yield takeLatest(types.FETCH_TIME_DEDUCTION_SHIFT_LATE_REQUEST, fetchShiftLateSaga);
  yield takeLatest(types.SAVE_TIME_DEDUCTION_SHIFT_LATE_REQUEST, saveShiftLateSaga);
  yield takeLatest(types.FETCH_TIME_DEDUCTION_SHIFT_LATE_CANCEL_REQUEST, fetchShiftLateCancelSaga);
  yield takeLatest(types.SAVE_TIME_DEDUCTION_SHIFT_LATE_CANCEL_REQUEST, saveShiftLateCancelSaga);
  // yield takeLatest(types.FETCH_VIEW_PUNCH_ORDERS_REQUEST, fetchViewPunchOrdersSaga);

  yield takeLatest(types.FETCH_SHIFT_LATE_APPROVAL_REQUEST, fetchShiftLateApprovalSaga);
  yield takeLatest(types.SAVE_SHIFT_LATE_APPROVAL_REQUEST, saveShiftLateApprovalSaga);

  yield takeLatest(types.FETCH_LATE_REPORT_REQUEST, fetchLateReportSaga);
  yield takeLatest(types.FETCH_LATE_CONSOLIDATED_REPORT_REQUEST, fetchLateConsolidatedReportSaga);

  yield takeLatest(types.FETCH_SHIFT_LATE_APPROVAL_EMPLOYEE_REQUEST, fetchShiftLateApprovalEmployeeSaga);
   yield takeLatest(types.FETCH_SHIFT_LATE_CANCEL_EMPLOYEE_REQUEST, fetchShiftLateCancelEmployeeSaga);
}
